
const SchedulingVC = () => {
  return (
    <div>SchedulingVC</div>
  )
}

export default SchedulingVC